export default __webpack_public_path__ + "static/media/Background 5_00039.f47f1a44.png";